<div *ngIf="state !== 'none'"
     class="border-b"
     [ngClass]="state === 'needs-setup' ? 'bg-amber-50 border-amber-200' : 'bg-rose-50 border-rose-200'">
    <div class="container-fluid px-4 py-3">
        <div class="flex items-start gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 [attr.stroke]="state === 'needs-setup' ? '#b45309' : '#be123c'"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 mt-0.5">
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>

            <div class="flex flex-col gap-1">
                <span class="text-sm font-semibold"
                      [ngClass]="state === 'needs-setup' ? 'text-amber-900' : 'text-rose-900'">
                    {{ state === 'needs-setup' ? "Let's finish setting up your account" : "No products linked to your feed" }}
                </span>

                <p class="text-sm m-0" [ngClass]="state === 'needs-setup' ? 'text-amber-800' : 'text-rose-800'">
                    <ng-container *ngIf="state === 'needs-setup'">
                        Thanks for signing up to Stockistly! If you need a hand setting up your feed, or have any questions, we're here to help.
                    </ng-container>
                    <ng-container *ngIf="state === 'no-variants-linked'">
                        This usually points to an issue with your feed configuration, and it's normally a quick fix.
                    </ng-container>
                </p>

                <div class="flex flex-col gap-1 mt-0.5">
                    <a href="mailto:hello@stockistly.com"
                       class="text-sm font-semibold underline hover:no-underline w-fit"
                       [ngClass]="state === 'needs-setup' ? 'text-amber-900' : 'text-rose-900'">
                        Email us at hello&#64;stockistly.com
                    </a>
                    <button type="button"
                            class="text-sm font-semibold underline hover:no-underline w-fit text-left"
                            [ngClass]="state === 'needs-setup' ? 'text-amber-900' : 'text-rose-900'"
                            (click)="onStartChat()">
                        Start a live chat by clicking here
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
